export default __webpack_public_path__ + "static/media/mobile-video.3b9bfcf2.mp4";